module.exports = __webpack_public_path__ + "static/media/ic_alert-time.a2fe6056.svg";